// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.
var _AnsiSgrParser_instances, _AnsiSgrParser_state, _AnsiSgrParser_parseSgrParams, _AnsiSgrParser_applySgr, _AnsiSgrParser_sgrColorToCss, _AnsiSgrParser_ansiStateToStyle;
import { __classPrivateFieldGet } from "tslib";
export class AnsiSgrParser {
    constructor() {
        _AnsiSgrParser_instances.add(this);
        _AnsiSgrParser_state.set(this, {
            bold: false,
            underline: false,
            inverse: false,
            fg: undefined,
            bg: undefined
        });
    }
    process(input) {
        var _a;
        let lastIndex = 0;
        let searchIndex = 0;
        const segments = [];
        const pushSegmentIfText = (text) => {
            if (!text)
                return;
            const style = __classPrivateFieldGet(this, _AnsiSgrParser_instances, "m", _AnsiSgrParser_ansiStateToStyle).call(this, __classPrivateFieldGet(this, _AnsiSgrParser_state, "f"));
            segments.push({ text, style });
        };
        while (searchIndex < input.length) {
            const escapeIndex = input.indexOf('\u001b[', searchIndex);
            if (escapeIndex < 0)
                break;
            const suffixMatch = (_a = /^[0-9;]*m/.exec(input.slice(escapeIndex + 2))) !== null && _a !== void 0 ? _a : undefined;
            if (!suffixMatch) {
                searchIndex = escapeIndex + 2;
                continue;
            }
            if (escapeIndex > lastIndex) {
                pushSegmentIfText(input.slice(lastIndex, escapeIndex));
            }
            const sequenceEnd = escapeIndex + 2 + suffixMatch[0].length;
            const seq = input.slice(escapeIndex, sequenceEnd);
            try {
                __classPrivateFieldGet(this, _AnsiSgrParser_instances, "m", _AnsiSgrParser_applySgr).call(this, __classPrivateFieldGet(this, _AnsiSgrParser_instances, "m", _AnsiSgrParser_parseSgrParams).call(this, seq));
            }
            catch (_b) {
                // Ignore malformed control sequences.
            }
            lastIndex = sequenceEnd;
            searchIndex = sequenceEnd;
        }
        if (lastIndex < input.length) {
            pushSegmentIfText(input.slice(lastIndex));
        }
        return segments;
    }
}
_AnsiSgrParser_state = new WeakMap(), _AnsiSgrParser_instances = new WeakSet(), _AnsiSgrParser_parseSgrParams = function _AnsiSgrParser_parseSgrParams(seq) {
    let s = seq;
    if (s.startsWith('\u001b[')) {
        s = s.slice(2);
    }
    if (s.endsWith('m')) {
        s = s.slice(0, -1);
    }
    if (!s)
        return [0];
    return s.split(';').map((p) => Number(p || 0));
}, _AnsiSgrParser_applySgr = function _AnsiSgrParser_applySgr(params) {
    if (!params || !params.length)
        params = [0];
    for (const p of params) {
        if (p === 0) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").bold = false;
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").underline = false;
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").inverse = false;
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").fg = undefined;
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").bg = undefined;
        }
        else if (p === 1) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").bold = true;
        }
        else if (p === 4) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").underline = true;
        }
        else if (p === 7) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").inverse = true;
        }
        else if (p === 22) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").bold = false;
        }
        else if (p === 24) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").underline = false;
        }
        else if (p >= 30 && p <= 37) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").fg = __classPrivateFieldGet(this, _AnsiSgrParser_instances, "m", _AnsiSgrParser_sgrColorToCss).call(this, p - 30, false);
        }
        else if (p === 39) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").fg = undefined;
        }
        else if (p >= 40 && p <= 47) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").bg = __classPrivateFieldGet(this, _AnsiSgrParser_instances, "m", _AnsiSgrParser_sgrColorToCss).call(this, p - 40, false);
        }
        else if (p === 49) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").bg = undefined;
        }
        else if (p >= 90 && p <= 97) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").fg = __classPrivateFieldGet(this, _AnsiSgrParser_instances, "m", _AnsiSgrParser_sgrColorToCss).call(this, p - 90, true);
        }
        else if (p >= 100 && p <= 107) {
            __classPrivateFieldGet(this, _AnsiSgrParser_state, "f").bg = __classPrivateFieldGet(this, _AnsiSgrParser_instances, "m", _AnsiSgrParser_sgrColorToCss).call(this, p - 100, true);
        }
    }
}, _AnsiSgrParser_sgrColorToCss = function _AnsiSgrParser_sgrColorToCss(idx, bright) {
    const base = ['#000000', '#a00', '#0a0', '#aa0', '#00a', '#a0a', '#0aa', '#ddd'];
    const brightMap = [
        '#555',
        '#ff5555',
        '#55ff55',
        '#ffff55',
        '#5555ff',
        '#ff55ff',
        '#55ffff',
        '#fff'
    ];
    return bright ? brightMap[idx] || base[idx] : base[idx];
}, _AnsiSgrParser_ansiStateToStyle = function _AnsiSgrParser_ansiStateToStyle(state) {
    const styles = [];
    if (state.fg)
        styles.push('color: ' + state.fg);
    if (state.bg)
        styles.push('background-color: ' + state.bg);
    if (state.bold)
        styles.push('font-weight: 700');
    if (state.underline)
        styles.push('text-decoration: underline');
    if (state.inverse)
        styles.push('filter: invert(100%)');
    return styles.join('; ');
};
//# sourceMappingURL=ansiSgrParser.js.map